var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 526 396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cdeeff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "js"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "241.7 13.38 241.7 48.9 221.15 48.9 221.15 62.06 253.28 62.06 253.28 13.38 241.7 13.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "260.25 13.38 303.22 13.38 303.7 25.39 271.86 25.39 271.86 32.26 303.7 32.26 303.7 62.06 260.25 62.06 260.7 49.38 291.7 49.38 291.7 43.38 260.25 42.71 260.25 13.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.7,85.38l24,268,107.24,29.95L370.7,353.38l23.48-268Zm120,233L177.7,297V267.38l47,13.39V137.38h27Zm94-152-47-1v50l44-7-8,91-62.84,19V288.9l39.84-12.52,3-36-42.84,7.49V137.38h77Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJs);
export default __webpack_public_path__ + "static/media/icon-js.88573fb7cd3f077b130ef48b38dfe96e.svg";
export { ForwardRef as ReactComponent };